import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { HeadingStyles } from "./Heading.styles";
export var Heading = function (_a) {
    var title = _a.title;
    var sx = HeadingStyles();
    return (_jsx(Typography, { variant: "h3", sx: sx.wrapper, children: title }));
};
